module.exports = __webpack_public_path__ + "static/img/share.430012e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/share.png
// module id = O6+D
// module chunks = 1 3